import React from "react"
import { PageHero } from "../ui/page-hero"

export function InsightsHero() {
  return (
    <PageHero
      title="Insights"
      description="Explore our thinking on AI strategy, Knowledge Architecture and the future of practical AI implementation."
      backgroundImage="/images/backgrounds/flickr-365822321.jpg"
      backgroundAlt="Insights"
    />
  )
} 